import state from "./moduleStatusState.js";
import mutations from "./moduleStatusMutations.js";
import actions from "./moduleStatusActions.js";
import getters from "./moduleStatusGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
